const authRoutes = {
	path: 'auth',
	component: () => import('./module-layout.vue'),
	children: [
		{
			path: 'database-creation-loading',
			component: () => import('./pages/database-creation-loading/index.vue'),
		},
	],
};

export { authRoutes };
